import { buildCookieString } from './cookie-utils';

export const FUNNEL_SESSION_ID_KEY = 'funnel_session_id';
export const FUNNEL_SESSION_COUNT_KEY = 'funnel_session_count';
export const ASSIGNED_FUNNEL_ID_KEY = 'funnel_assigned_id';
export const ASSIGNED_FUNNEL_NAME_KEY = 'funnel_assigned_name';
export const ASSIGNED_FUNNEL_EXPIRES_AT_KEY = 'funnel_assigned_expires_at';
export const DECLINED_STEPS_KEY = 'funnel_declined_steps';
export const CURRENT_STEP_KEY_PREFIX = 'funnel_current_step_';
export const FUNNEL_RUNTIME_VERSION_KEY = 'funnel_runtime_version';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name: string, value: string | null): void {
  if (typeof document === 'undefined') return;
  document.cookie = buildCookieString(name, value, window.location.hostname);
}

export function currentStepStorageKey(funnelId: string): string {
  return `${CURRENT_STEP_KEY_PREFIX}${funnelId}`;
}

export function clearFunnelRuntimeState(): void {
  if (typeof window === 'undefined') return;

  try {
    const keysToClear: string[] = [];
    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);
      if (!key) continue;
      if (
        key === FUNNEL_SESSION_ID_KEY ||
        key === FUNNEL_SESSION_COUNT_KEY ||
        key === ASSIGNED_FUNNEL_ID_KEY ||
        key === ASSIGNED_FUNNEL_NAME_KEY ||
        key === ASSIGNED_FUNNEL_EXPIRES_AT_KEY ||
        key === DECLINED_STEPS_KEY ||
        key === FUNNEL_RUNTIME_VERSION_KEY ||
        key.startsWith(CURRENT_STEP_KEY_PREFIX)
      ) {
        keysToClear.push(key);
      }
    }

    for (const key of keysToClear) {
      sessionStorage.removeItem(key);
    }
  } catch {
    /* ignore */
  }

  if (typeof document === 'undefined') return;
  const cookieNames = [
    FUNNEL_SESSION_ID_KEY,
    ASSIGNED_FUNNEL_ID_KEY,
    ASSIGNED_FUNNEL_NAME_KEY,
    ASSIGNED_FUNNEL_EXPIRES_AT_KEY,
  ];

  const rawCookies = document.cookie ? document.cookie.split('; ') : [];
  for (const cookie of rawCookies) {
    const name = cookie.split('=')[0];
    if (cookieNames.includes(name) || name.startsWith(CURRENT_STEP_KEY_PREFIX)) {
      writeCookie(name, null);
    }
  }
}

export function syncFunnelRuntimeVersion(runtimeVersion: string | null | undefined): void {
  if (typeof window === 'undefined') return;
  const normalizedRuntimeVersion = runtimeVersion?.trim() || null;
  if (!normalizedRuntimeVersion) return;

  try {
    const storedVersion = sessionStorage.getItem(FUNNEL_RUNTIME_VERSION_KEY) ?? readCookie(FUNNEL_RUNTIME_VERSION_KEY);
    if (storedVersion && storedVersion !== normalizedRuntimeVersion) {
      clearFunnelRuntimeState();
    }

    sessionStorage.setItem(FUNNEL_RUNTIME_VERSION_KEY, normalizedRuntimeVersion);
    writeCookie(FUNNEL_RUNTIME_VERSION_KEY, normalizedRuntimeVersion);
  } catch {
    /* ignore */
  }
}
